export const createUrl = (url: string, params?: { [n: string]: any }) => {
    if (!params) return url

    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
            searchParams.set(key, String(value))
        }
    })

    const queryText = searchParams.toString()
    return queryText ? `${url}?${queryText}` : url
}
